import React, { Key } from 'react';

import { Menu } from 'antd';
import { useSelector } from 'react-redux';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import { COLORS } from '../../utils/theme/colors';

interface IOperationsCommands {
  mode: string;
  setMenuKey: (key: Key) => any;
}

const OperationsCommands = ({ mode, setMenuKey }: IOperationsCommands): any => {
  const routes = useSelector((state: any) => state.user.routes);

  return (
    <OperationsCommandsWrapper>
      <Menu
        onClick={({ key }) => {
          setMenuKey(key);
        }}
      >
        <Menu.Item
          key='change_availability'
          disabled={routes && routes.find(({ path }) => path === '/operations/change_availability') ? false : true}
        >
          {T('Change Availability')}
        </Menu.Item>
        <Menu.Item
          key='start'
          disabled={routes && routes.find(({ path }) => path === '/operations/remote_start') ? false : true}
        >
          {T('Remote Start Transaction')}
        </Menu.Item>
        <Menu.Item
          key='stop'
          disabled={routes && routes.find(({ path }) => path === '/operations/remote_stop') ? false : true}
        >
          {T('Remote Stop Transaction')}
        </Menu.Item>
        <Menu.Item
          key='reset'
          disabled={routes && routes.find(({ path }) => path === '/operations/remote_reset') ? false : true}
        >
          {T('Reset')}
        </Menu.Item>
        <Menu.Item
          key='get_configuration'
          disabled={routes && routes.find(({ path }) => path === '/operations/get_configuration') ? false : true}
        >
          {T('Get Configuration')}
        </Menu.Item>
        <Menu.Item
          key='change_configuration'
          disabled={routes && routes.find(({ path }) => path === '/operations/change_configuration') ? false : true}
        >
          {T('Change Configuration')}
        </Menu.Item>
        <Menu.Item
          key='clear_cache'
          disabled={routes && routes.find(({ path }) => path === '/operations/clear_cache') ? false : true}
        >
          {T('Clear Cache')}
        </Menu.Item>
        <Menu.Item
          key='get_diagnostics'
          disabled={routes && routes.find(({ path }) => path === '/operations/get_diagnostics') ? false : true}
        >
          {T('Get Diagnostics')}
        </Menu.Item>
        <Menu.Item
          key='unlock_connector'
          disabled={routes && routes.find(({ path }) => path === '/operations/unlock_connector') ? false : true}
        >
          {T('Unlock Connector')}
        </Menu.Item>
        <Menu.Item
          key='update_firmware'
          disabled={routes && routes.find(({ path }) => path === '/operations/update_firmware') ? false : true}
        >
          {T('Update Firmware')}
        </Menu.Item>
        <Menu.Item
          key='data_transfer'
          disabled={routes && routes.find(({ path }) => path === '/operations/data_transfer') ? false : true}
        >
          {T('Data Transfer')}
        </Menu.Item>
        <Menu.Item key='power_limit' disabled>
          {T('Power Limit')}
        </Menu.Item>
        <Menu.Item
          key='trigger_message'
          disabled={
            routes && routes.find(({ path }) => path === '/operations/trigger_message') && mode === 'v1.6'
              ? false
              : true
          }
        >
          {T('Trigger Message')}
        </Menu.Item>
        <Menu.Item
          key='set_charging_profile'
          disabled={
            routes && routes.find(({ path }) => path === '/operations/set_charging_profile') && mode === 'v1.6'
              ? false
              : true
          }
        >
          {T('Set Charging Profile')}
        </Menu.Item>
        <Menu.Item
          key='clear_charging_profile'
          disabled={
            routes && routes.find(({ path }) => path === '/operations/clear_charging_profile') && mode === 'v1.6'
              ? false
              : true
          }
        >
          {T('Clear Charging Profile')}
        </Menu.Item>
        <Menu.Item
          key='send_local_list'
          disabled={routes && routes.find(({ path }) => path === '/operations/send_local_list') ? false : true}
        >
          {T('Send Local List')}
        </Menu.Item>
        <Menu.Item
          key='get_composite_schedule'
          disabled={
            routes && routes.find(({ path }) => path === '/operations/get_composite_schedule') && mode === 'v1.6'
              ? false
              : true
          }
        >
          {T('Get Composite Schedule')}
        </Menu.Item>
        <Menu.Item
          key='reserve_now'
          disabled={routes && routes.find(({ path }) => path === '/operations/reserve_now') ? false : true}
        >
          {T('Reserve Now')}
        </Menu.Item>
      </Menu>
    </OperationsCommandsWrapper>
  );
};

const OperationsCommandsWrapper = styled.div`
  border: 1px solid ${COLORS.stone};
  border-radius: 2px;
  margin: 0.5em 1em 0.5em 0;
`;

export default OperationsCommands;
